import { Camera, Check, Tag } from "lucide-react";

// To use a real app screenshot, pass it via the `screenshot` prop:
// <PhoneMockup screenshot="/screenshots/listing.png" />
const PhoneMockup = ({ screenshot, testId = "phone-mockup" }) => (
  <div data-testid={testId} className="relative mx-auto w-[280px] sm:w-[320px]">
    <div className="rounded-[2.5rem] border border-linestrong bg-surface3 p-2 shadow-[0_24px_80px_rgba(0,0,0,0.6)]">
      <div className="relative overflow-hidden rounded-[2rem] bg-surface">
        {screenshot ? (
          <img src={screenshot} alt="Sellcraft app screenshot" className="h-auto w-full" />
        ) : (
          <div className="flex h-[560px] flex-col px-5 pb-6 pt-4">
            <div className="flex items-center justify-between text-[10px] text-onsurface2">
              <span>9:41</span>
              <span className="mx-auto h-5 w-24 rounded-full bg-surface3" />
              <span>5G</span>
            </div>

            <p className="mt-5 text-center font-display text-lg font-bold uppercase tracking-[1.5px] text-onsurface">
              Sell<span className="text-brand-light">craft</span>
            </p>

            <div className="relative mt-5 h-44 overflow-hidden rounded-lg border border-line bg-surface2">
              <div className="flex h-full flex-col items-center justify-center gap-2 text-onsurface2">
                <Camera className="h-8 w-8 text-brand-light" />
                <span className="text-xs">Analyzing photo…</span>
              </div>
              <div className="absolute left-3 right-3 h-0.5 rounded-full bg-brand-light shadow-[0_0_16px_rgba(111,156,255,0.9)] animate-scan-line" />
            </div>

            <div className="mt-4 rounded-lg border border-line bg-surface2 p-4">
              <div className="flex items-center gap-2">
                <span className="rounded-full bg-brand-tint px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-brand-tinttext">Identified</span>
                <Check className="h-3.5 w-3.5 text-success" />
              </div>
              <p className="mt-2 font-display text-base font-semibold text-onsurface">Vintage Leather Jacket — Brown, M</p>
              <div className="mt-2 flex items-center gap-2">
                <Tag className="h-4 w-4 text-success" />
                <span className="text-sm font-semibold text-success">£45 – £60</span>
                <span className="text-[10px] text-onsurface2">based on 23 sold comparables</span>
              </div>
            </div>

            <div className="mt-4 flex gap-2">
              {["eBay", "Facebook", "Gumtree"].map((m) => (
                <span key={m} className="rounded-full border border-line bg-surface2 px-3 py-1 text-[10px] font-medium text-onsurface2">{m}</span>
              ))}
            </div>

            <div className="mt-auto rounded-lg bg-brand py-3 text-center font-display text-sm font-bold uppercase tracking-wider text-white shadow-cta">
              Post listing
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default PhoneMockup;
